import { Button, ButtonProps } from '@shopify/polaris';
import { FunctionComponent } from 'react';
import styled, { css } from 'styled-components';

const DestructiveSubduedButtonContainer = styled.div`
  .Polaris-Button {
    color: ${({ theme }) => theme.colors.destructive.hex};
  }
`;

export const DestructiveSubduedButton: FunctionComponent<ButtonProps> = (
  props,
) => {
  const { children } = props;
  return (
    <DestructiveSubduedButtonContainer>
      <Button {...props}>{children}</Button>
    </DestructiveSubduedButtonContainer>
  );
};

export const FlexboxContainer = styled.div`
  display: flex;
`;

export const ColumnContainer = styled.div`
  @media (min-width: 768px) {
    width: 50%;
  }
`;

/* Requires a width or max-width in px to work */
export const EllipsisTextContainer = styled.div`
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;

export const RemoveButtonText = styled.div`
  font-weight: 500;
  font-size: 14px;
  cursor: pointer;
`;

export const HeaderTitleBaseStyles = css`
  font-size: 32px;
  font-weight: 400;
  line-height: 32px;
`;

export const HeaderTitle = styled.div<{
  hideOnMobile?: boolean;
  margin?: string;
}>`
  ${HeaderTitleBaseStyles};
  margin: ${(props) => props.margin};

  @media (max-width: 768px) {
    display: ${(props) => (props.hideOnMobile ? 'none' : undefined)};
  }
`;

export const RadioStackContainer = styled.div`
  .Polaris-Stack__Item {
    border-radius: 0.4rem;
    &:hover {
      background-color: #f7f7f7;
    }
  }

  .Polaris-Choice {
    width: 100%;
  }

  .Polaris-Choice__Control {
    width: 0;
    margin: 0;
    height: 4rem;
  }
  .Polaris-RadioButton__Backdrop {
    &:before {
      background-color: transparent;
    }
    &:after {
      display: none;
    }
    background-color: transparent;
    border-radius: 0;
    border: none;
    width: 0;
  }

  .Polaris-RadioButton__Input:checked + .Polaris-RadioButton__Backdrop:before {
    border-radius: 0 4px 4px 0;
    background-color: ${({ theme }) => theme.colors.primary.hex};
    left: -15px;
    height: 100%;
  }

  .Polaris-Choice__Label {
    align-self: center;
    font-size: 14px;
    padding-left: 0.8rem;
  }
`;

export const SubHeaderTitle = styled.div<{
  margin?: string;
}>`
  ${HeaderTitleBaseStyles};
  margin: ${(props) => props.margin};
`;

export const CardTitleSmall = styled.div<{
  margin?: string;
}>`
  column-gap: 1rem;
  display: flex;
  font-weight: 600;
  font-size: 17px;
  margin: ${(props) => props.margin};
`;

export const CardSubTitle = styled.div<{
  margin?: string;
}>`
  font-size: 14px;
  margin: ${(props) => props.margin ?? '1.6rem 0 0 0'};
`;

export const HelpText = styled.div<{
  marginBottom?: string;
  marginTop?: string;
}>`
  font-weight: 400;
  line-height: 2rem;
  color: #6d7175;
  font-size: 1.4rem;
  margin-bottom: 0.4rem;
  margin-bottom: ${(props) => props.marginBottom};
  margin-top: ${(props) => props.marginTop};
`;
